import React from "react";
import ReactLoading from "react-loading";

const Loading = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "white",
        zIndex: 9999,
      }}
    >
      <ReactLoading
        type="spinningBubbles"
        color="#022B44"
        height={100}
        width={100}
      />
    </div>
  );
};

export default Loading;
